import { notification } from 'antd/lib'
import { useUserDetails } from 'Contexts/UserDetailsContext'
import useService from 'Hooks/use-service'
import { useEffect } from 'react'
import { getAttemptHistoryByUserId } from 'Services/exams.service'

export const useAttemptHistory = () => {
    const userDetails = useUserDetails()
    const { data, isLoading, error, trigger } = useService(getAttemptHistoryByUserId)

    useEffect(() => {
        if (userDetails) {
            trigger(userDetails.userID)
        }
    }, [trigger, userDetails])

    useEffect(() => {
        if (error) {
            notification.error({
                message: (error as Error).message ?? 'Error in loading attempt history',
                description:
                    'Please try again. If you still face the issue, reach out to the project owner',
                placement: 'bottomLeft',
            })
        }
    }, [error])

    return { data: data?.attempts ?? [], isLoading, error }
}
